import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Fake because we don't save checkout package tree in the AdvancedFlow
 * collection, but necessary for frontend type system.
 */
export const baseCheckoutPackageSchema = defineSchema({ fields: {} });

export const examplebaseCheckoutPackageInstance: SchemaInstance<
  typeof baseCheckoutPackageSchema
> = {};

export function createbaseCheckoutPackageInstance(): SchemaInstance<
  typeof baseCheckoutPackageSchema
> {
  return {};
}
